<template>
    <div class="scroll-table rs-el-table">
        <el-table
            :data="[]"
            style="width: 100%; height: auto;"
            class="top"
            :show-summary="false"
            header-row-class-name="tableHeader"
            :header-cell-style="{'text-align':'center'}"
        >
            <el-table-column
                v-for="item in tableHead"
                :prop="item.props"
                :label="item.label"
                :key="item.label"
                :width="item.width||''"
                :type="item.type"
            >

            </el-table-column>
        </el-table>

        <vue3-seamless-scroll
            class="seamless-warp scroll"
            :list="tableData"
            :step="0.3"
            hover
            style="width: 100%"
        >
            <el-table
                :data="tableData"
                style="width: 100%"
                stripe
                :show-header="false"
                row-class-name="rowStyle"
            >
                <el-table-column
                    v-for="item in tableHead"
                    :prop="item.props"
                    :label="item.label"
                    :align="item.align || 'center'"
                    :key="item.label"
                    :width="item.width||''"
                    :type="item.type"
                >
                  <template v-if="!item.type" #default="scope">
                      <span style="white-space: nowrap;" :title="scope.row[item.props]">
                          {{getValue(item,scope.row[item.props])}}
                      </span>
                  </template>
                </el-table-column>
            </el-table>
        </vue3-seamless-scroll>
    </div>

</template>

<script setup>
import {Vue3SeamlessScroll} from "vue3-seamless-scroll";
import HighBrandDeveloperSearch from "@/view/insight/urban/components/highBrandDeveloperSearch.vue";
import {landAreaFormat, landUseAreaFormat, rentPriceFormat, warehouseArea} from "@/tool/number";


const props = defineProps({
    tableHead:{
        type:Array,
        default:[]
    },
    tableData:{
        type:Array,
        default:[]
    },
})

function getValue(item, val){
    let num = val

    if(item.isLandUseArea){
      return landUseAreaFormat(val)
    }

    if(item.isArea){
      return warehouseArea(val);
    }

    if(item.isEstimatedPrice){
      return rentPriceFormat(val);
    }

    if(item.fixed) {
        num =val?Number(val).toFixed(item.fixed):''
    }
    if(item.thousandth) {
        num = val?Number(val).toLocaleString():''
    }
    return num
}
</script>

<style lang="less">
.scroll-table{
    width:100%;
    height: 100%;

    .seamless-warp {
        height: calc(100% - 60px);
        overflow: hidden;
        .rowStyle{
            height: 46px;
        }
    }

    .top {
        .el-table__body-wrapper {
            display: none;
        }
    }
    .el-table {
        .tableHeader {
            font-size: 14px;
            font-weight: 400;
            color: #333333;

            .cell {
                display: flex;
                align-items: center;
            }
        }
    }

}

</style>
